import React from 'react';
import { BusinessHero } from '@/components/ui/content-blocks';
import { useTranslation } from '@/hooks/useTranslation';

const HeaderSection = () => {
  const { t } = useTranslation();
  
  return (
    <BusinessHero
      title="Microsoft Business Central"
      titleHighlight="Business Central"
      description="Das ERP-System, das mit deinem Unternehmen wächst. Alle wichtigen Geschäftsprozesse in einer einzigen Software - einfach, sicher und immer aktuell."
      details="Schluss mit Excel-Listen und verschiedenen Programmen für jeden Bereich. Mit Business Central hast du Finanzen, Vertrieb, Einkauf und Lager endlich an einem Ort. Deine Mitarbeiter arbeiten effizienter, du behältst den Überblick und kannst bessere Entscheidungen treffen."
      backgroundStyle="blue"
      primaryCTA={{
        label: "Funktionen ansehen",
        href: "#erp-features"
      }}
    />
  );
};

export default HeaderSection; 